import React, { forwardRef } from "react";
import {
  useVisuallyHidden,
  VisuallyHiddenProps as AriaVisuallyHiddenProps,
} from "react-aria";

export type VisuallyHiddenProps = AriaVisuallyHiddenProps;

/**
 * A wrapper component that hides its children visually while keeping them in
 * the DOM and accessible to screen readers.
 */
export const VisuallyHidden = forwardRef<HTMLDivElement, VisuallyHiddenProps>(
  ({ children, isFocusable, ...props }, ref) => {
    const { visuallyHiddenProps } = useVisuallyHidden({
      isFocusable,
    });

    return (
      <div {...visuallyHiddenProps} {...props} ref={ref}>
        {children}
      </div>
    );
  },
);
